import {getTestProps} from '@benchling/js-test-utils';
import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import {FONT_PROXIMA_19, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {assertNever} from 'util/Types';

import {DataLayoutSection as DataLayoutSectionType, LayoutPath} from './DataLayoutTypes';
import GridSection from './GridSection';
import TabSection from './TabSection';

interface DataLayoutSectionProps {
  layoutPath: LayoutPath;
  section: DataLayoutSectionType;
}

/** @package */
export function SectionTitle({title}: {title: string}): JSX.Element {
  return <div className={css(styles.title)}>{title}</div>;
}

/** @package */
export default function DataLayoutSection({layoutPath, section}: DataLayoutSectionProps): JSX.Element {
  let sectionContents;
  if (section.type === 'GRID') {
    sectionContents = <GridSection gridSection={section} layoutPath={layoutPath} />;
  } else if (section.type === 'TAB') {
    sectionContents = <TabSection tabSection={section} layoutPath={layoutPath} />;
  } else {
    assertAndContinue(false, 'Found unexpected section type in layout', {
      sectionType: assertNever(section).type,
    });
    sectionContents = null;
  }
  return (
    <div {...getTestProps({component: 'DataLayoutSection', element: 'root'})}>
      {section.title && <SectionTitle title={section.title} />}
      <div className={css(styles.sectionContents)}>{sectionContents}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  title: {
    ...FONT_PROXIMA_19,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    margin: '10px',
  },
  sectionContents: {
    margin: 10,
  },
});
